import * as Styled from './styles'

export default function TextFooter({ children }) {
  return <Styled.TextFooter>{children}</Styled.TextFooter>
}
